// ============================================================================
// CURRENCY ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithQuery } from './base.endpoints';

export const currencyEndpoints = {
  /** GET /api/v1/common/currencies?searchTerm=... */
  list: (searchTerm?: string) => {
    // buildEndpoint adds the /v1 version prefix; buildEndpointWithQuery
    // expects a pre-built endpoint (see comment in base.endpoints.ts).
    // Passing the raw '/common/currencies' to buildEndpointWithQuery would
    // skip the version prefix and hit /api/common/currencies (404).
    const base = buildEndpoint('/common/currencies');
    return searchTerm ? buildEndpointWithQuery(base, { searchTerm }) : base;
  },
} as const;
